import { ErrandInterface } from './errand.model';
import { ErrandType } from './errand-type.enum';

export class FlyToObjectErrandModel implements ErrandInterface {
    type = ErrandType.flyToObject;
    value: string;
    params?: {
        duration: number;
    };

    constructor(
        objectId: string | null
    ) {
        this.value = objectId;
    }
}
